// extracted by mini-css-extract-plugin
export default {"container":"MasterDataMenu_container__7YEaB"};